module.exports = "/_next/static/images/mobilelocation-8db8710818dcf20286547ce0b7c40196.svg";